<template>
  <div class="">
    <div
      class="relative h-full flex flex-col md:flex-row items-center justify-between py-8 md:py-0 carroussel-container2"
    >
      <div
        class="w-full md:w-1/2 flex flex-col justify-center z-10 text-center md:text-left px-4 md:px-0"
      >
        <div class="inline-block mb-4 self-center md:self-start">
          <span
            class="px-3 py-1 text-sm font-semibold text-primary-foreground bg-primary rounded-full "
            >{{ items[current].head }}</span
          >
        </div>
        <h1
          class="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-4 leading-tight "
        >
          <span class="texto-claro"> {{ items[current].title }}&nbsp;</span>
          <span class="text-primary">{{
            items[current].title2
          }}</span>
        </h1>
        <p
          class="text-lg text-muted-foreground mb-6 max-w-lg mx-auto md:mx-0 text-white "
        >
          <span class="texto-claro text-shadow-custom"> {{ items[current].subtitle }}</span>
        </p>
        <div
          class="d-flex justify-content-center"
        >
          <button
            @click="$router.push('/products')"
            data-slot="button"
            class="mr-3 rounded inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([class*='size-'])]:size-4 shrink-0 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive bg-primary text-primary-foreground hover:bg-primary/90 h-10 rounded-md px-6 has-[&gt;svg]:px-4 gap-2"
          >
            Explorar Produtos</button
          ><button
            data-slot="button"
            @click="mailto"
            class="rounded inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([class*='size-'])]:size-4 shrink-0 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive border bg-transparent shadow-xs hover:bg-accent dark:bg-transparent dark:border-input dark:hover:bg-input/50 h-10 rounded-md px-6 has-[&gt;svg]:px-4"
          >
            <span class="texto-claro">Solicitar Demonstração</span>
          </button>
        </div>
        <div class="grid grid-cols-3 gap-4 mt-8 md:mt-12">
          <div v-for="(info, index) in items[current].infos" :key="index">
            <p class="text-2xl md:text-3xl font-bold text-primary">
              {{ info.value }}
            </p>
            <p class="text-xs md:text-sm text-muted-foreground">
              {{ info.description }}
            </p>
          </div>
        </div>
      </div>
      
      <div
        class="w-full md:w-1/2 h-64 md:h-full flex items-center justify-center relative perspective px-4 md:px-0"
      >
        <div
          class="relative w-full h-full flex items-center justify-center"
          v-if="items.length > 1"
          style="
            scale: 0.5;
            opacity: 0.5;
            position: absolute;
            left: -30%;
            z-index: 1;
          "
        >
          <div class="relative z-20 w-40 h-48 md:w-56 md:h-64 mx-4 md:mx-0">
            <div
              style="scale: 1.3"
              class="bg-item-produto-carrossel2 relative w-full h-full bg-gradient-to-br from-primary/30 via-secondary to-card rounded-xl p-6 flex items-center justify-center overflow-hidden group shadow-2xl"
            >
              <div
                class="absolute inset-0 bg-gradient-to-t from-primary/40 via-transparent to-primary/20 opacity-0 group-hover:opacity-100 transition-all duration-500"
              ></div>
              <div
                class="absolute -inset-1 bg-gradient-to-r from-primary via-blue-500 to-primary rounded-xl blur-2xl opacity-0 group-hover:opacity-75 transition-all duration-500 -z-10"
              ></div>
              <img
                :src="items[prev].image" 
                :alt="items[prev].nome" 
                class="w-full h-full object-contain relative z-10 transform group-hover:scale-105 transition-transform duration-500"
              />
              <div
                v-if="false"
                class="absolute bottom-4 right-4 bg-primary/90 backdrop-blur-sm px-3 py-1 rounded-full text-sm font-bold text-primary-foreground z-20"
              >
                {{ items[prev].tag }}
              </div>
            </div>
            <div class="text-center mt-4 pt-4" v-if="false">
              <h2
                class="text-xl md:text-2xl font-bold text-foreground texto-claro"
              >
                {{ items[prev].nome }}
              </h2>
            </div>
          </div>
        </div>

        <div
          class="relative w-full h-full flex items-center justify-center"
          style="z-index: 2"
        >
          <div class="relative z-20 w-40 h-48 md:w-56 md:h-64 mx-4 md:mx-0">
            <div
              style="scale: 2"
              class="bg-item-produto-carrossel2 relative w-full h-full bg-gradient-to-br from-primary/30 via-secondary to-card rounded-xl p-6 flex items-center justify-center overflow-hidden group shadow-2xl"
            >
              <div
                class="absolute inset-0 bg-gradient-to-t from-primary/40 via-transparent to-primary/20 opacity-0 group-hover:opacity-100 transition-all duration-500"
              ></div>
              <div
                class="absolute -inset-1 bg-gradient-to-r from-primary via-blue-500 to-primary rounded-xl blur-2xl opacity-0 group-hover:opacity-75 transition-all duration-500 -z-10"
              ></div>
              <img
                :src="items[current].image"
                :alt="items[current].nome"
                class="w-full h-full object-contain relative z-10 transform group-hover:scale-105 transition-transform duration-500"
              />
              <div
                style="scale: 0.4; margin-bottom: 10px; text-align: center"
                class="absolute bottom-4 right-4 bg-primary/90 backdrop-blur-sm px-3 py-1 rounded-full text-sm font-bold text-primary-foreground z-20"
              >
                {{ items[current].tag }}
              </div>
            </div>
            <br />
            <div class="text-center mt-4 pt-4">
              <h2
                class="text-xl md:text-2xl font-bold text-foreground texto-claro"
              >
                {{ items[current].nome }}
              </h2>
            </div>
          </div>
        </div>

        <div
          class="relative w-full h-full flex items-center justify-center"
          v-if="items.length > 1"
          style="
            scale: 0.5;
            opacity: 0.5;
            position: absolute;
            left: 20%;
            z-index: 1;
          "
        >
          <div class="relative z-20 w-40 h-48 md:w-56 md:h-64 mx-4 md:mx-0">
            <div
              style="scale: 1.3"
              class="bg-item-produto-carrossel2 relative w-full h-full bg-gradient-to-br from-primary/30 via-secondary to-card rounded-xl p-6 flex items-center justify-center overflow-hidden group shadow-2xl"
            >
              <div
                class="absolute inset-0 bg-gradient-to-t from-primary/40 via-transparent to-primary/20 opacity-0 group-hover:opacity-100 transition-all duration-500"
              ></div>
              <div
                class="absolute -inset-1 bg-gradient-to-r from-primary via-blue-500 to-primary rounded-xl blur-2xl opacity-0 group-hover:opacity-75 transition-all duration-500 -z-10"
              ></div>
              <img
                :src="items[next].image" 
                :alt="items[next].nome" 
                class="w-full h-full object-contain relative z-10 transform group-hover:scale-105 transition-transform duration-500"
              />
              <div
                v-if="false"
                class="absolute bottom-4 right-4 bg-primary/90 backdrop-blur-sm px-3 py-1 rounded-full text-sm font-bold text-primary-foreground z-20"
              >
                {{ items[next].tag }}
              </div>
            </div>
            <div class="text-center mt-4 pt-4" v-if="false">
              <h2
                class="text-xl md:text-2xl font-bold text-foreground texto-claro"
              >
                {{ items[next].nome }}
              </h2>
            </div>
          </div>
        </div>
        
        <button
          @click="toPrevCarroussel"
          class="absolute top-1/2 -translate-y-1/2 z-30 p-2 rounded-full bg-primary/20 hover:bg-primary/40 transition-colors"
          style="left: -1%"
          aria-label="Previous product"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-chevron-left h-6 w-6 text-primary"
          >
            <path d="m15 18-6-6 6-6"></path>
          </svg></button
        >
        
        <button
          @click="toNextCarroussel"
          class="absolute top-1/2 -translate-y-1/2 z-30 p-2 rounded-full bg-primary/20 hover:bg-primary/40 transition-colors"
          style="right: -1%"
          aria-label="Next product"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-chevron-right h-6 w-6 text-primary"
          >
            <path d="m9 18 6-6-6-6"></path>
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$api.getBanners()
      .then(res => {
        if (res?.data?.banners && res.data.banners.length > 0) {
          this.items = res.data.banners;
          this.current = 0; // Inicia no primeiro item
          this.updateIndices();
        } else if (this.items.length > 0) {
          this.current = 0; // Usa dados de fallback e inicializa
          this.updateIndices();
        }
        console.log('peguei os banners', JSON.stringify(this.items));
      })
      .catch(error => {
        console.error("Erro ao carregar banners:", error);
        if (this.items.length > 0) {
          this.current = 0; // Usa dados de fallback e inicializa
          this.updateIndices();
        }
      });
    
    // Inicia o carrossel automático apenas se houver itens
    if (this.items.length > 1) {
        setInterval(() => {
            if (!this.automatic) return;
            this.nextCarroussel();
        }, 2500);
    }
  },

  data() {
    return {
      automatic: true,
      current: 0, // Índice do item principal
      prev: 0,    // Índice do item anterior (para preview)
      next: 0,    // Índice do item próximo (para preview)
      items: [
        // Itens de fallback (Mantenha ou remova conforme sua necessidade)
        {
          nome: "SFP 10G",
          tag: "10 Gbps",
          image: "/assets/img/example/CO-SFP-10G-BXU-20.png",
          head: "Tecnologia de Ponta",
          title: "Transceptores Ópticos de ",
          title2: "Alta Performance",
          subtitle: "Solução GPON para redes de acesso óptico",
          infos: [
            { value: "400G", description: "Velocidade Máxima" },
            { value: "5+", description: "Tipos de Módulos" },
            { value: "99.9%", description: "Confiabilidade" },
          ],
        },
        {
          nome: "GPON ONU",
          tag: "2.5 Gbps",
          image: "/assets/img/example/GPON-ONU-SFP.png",
          head: "Tecnologia de Ponta GPON",
          title: "Módulos Ópticos ",
          title2: "GPON de Acesso",
          subtitle: "ONU SFP para redes de acesso de fibra óptica",
          infos: [
            { value: "2.5G", description: "Velocidade Downlink" },
            { value: "1.25G", description: "Velocidade Uplink" },
            { value: "20 km", description: "Alcance Máximo" },
          ],
        },
        {
          nome: "SFP 10G",
          tag: "10 Gbps",
          image: "/assets/img/example/CO-SFP-10G-BXU-20.png",
          head: "Tecnologia de Ponta",
          title: "Transceptores Ópticos de ",
          title2: "Alta Performance",
          subtitle: "Solução GPON para redes de acesso óptico",
          infos: [
            { value: "400G", description: "Velocidade Máxima" },
            { value: "5+", description: "Tipos de Módulos" },
            { value: "99.9%", description: "Confiabilidade1" },
          ],
        },
        {
          nome: "GPON ONU",
          tag: "2.5 Gbps",
          image: "/assets/img/example/GPON-ONU-SFP.png",
          head: "Tecnologia de Ponta GPON",
          title: "Módulos Ópticos ",
          title2: "GPON de Acesso",
          subtitle: "ONU SFP para redes de acesso de fibra óptica",
          infos: [
            { value: "2.5G", description: "Velocidade Downlink" },
            { value: "1.25G", description: "Velocidade Uplink" },
            { value: "20 km", description: "Alcance Máximo" },
          ],
        },
        // Adicione mais itens de fallback conforme necessário
      ],
    };
  },
  methods: {
    // Calcula corretamente os índices 'prev' e 'next' com loop
    updateIndices() {
        const total = this.items.length;
        if (total === 0) return;

        // Calcula o índice anterior com loop (ex: 0 -> Último item)
        this.prev = (this.current - 1 + total) % total;

        // Calcula o índice próximo com loop (ex: Último item -> 0)
        this.next = (this.current + 1) % total;
    },

    // Ação do clique no botão de AVANÇAR
    toNextCarroussel() {
      this.automatic = false;
      this.nextCarroussel();
    },

    // Lógica de AVANÇO
    nextCarroussel() {
        if (this.items.length === 0) return;
        
        // Avança o índice atual e garante o loop
        this.current = (this.current + 1) % this.items.length;
        this.updateIndices();
    },

    // Ação do clique no botão de RETROCEDER (NOVO)
    toPrevCarroussel() {
        this.automatic = false;
        this.prevCarroussel();
    },

    // Lógica de RETROCESSO (NOVO)
    prevCarroussel() {
        if (this.items.length === 0) return;

        // Retrocede o índice atual e garante o loop
        // Adicionar this.items.length é necessário para que a operação de módulo funcione corretamente
        this.current = (this.current - 1 + this.items.length) % this.items.length;
        this.updateIndices();
    },

    mailto() {
      window.open("https://www.mx3network.com/contato");
    },
  },
};
</script>

<style scoped>
/* Estilos existentes */
.bg-item-produto-carrossel2 {
  background: transparent !important;
}

/* 1. Definindo o Container para o Efeito de Brilho */
.carroussel-container2 {
  height: 86vh !important;
  background-image: url("@/assets/img/banner/banner-base.jpg");
  background-position: center;
  background-size: auto;
  background-repeat: repeat-x;
  padding-right: 15%;
  padding-left: 15%;
  /* ✨ ALTERAÇÕES AQUI: Necessário para o posicionamento do ::before */
  position: relative;
  overflow: hidden;
}

/* 2. Aplicação do Efeito de Brilho (Grosso, Sutil e Lento) */
.carroussel-container2::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  height: 100%;
  width: 100%;
  z-index: 1;

  /* ✨ ALTERAÇÃO: Aumentando a largura da faixa e mantendo a sutileza */
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0) -50%,
    /* Início da faixa grossa (40%) */ rgba(255, 255, 255, 0.01) 70%,
    /* Pico do brilho (50% - 20% de opacidade) */ rgba(255, 255, 255, 0) 500%,
    /* Fim da faixa grossa (60%) */ rgba(255, 255, 255, 0) 100%
  );

  /* Mantido o ângulo e a velocidade lenta (8s) */
  transform: skewX(-45deg);
  animation: brilhoSuave 3s infinite ease-in-out;
}

/* 3. Definição da Animação */
@keyframes brilhoSuave {
  0% {
    left: -150%; /* Inicia o brilho completamente fora da div à esquerda */
  }
  100% {
    left: 150%; /* Move o brilho para fora da div à direita */
  }
}
.texto-claro {
  color: white !important;
}

.text-shadow--custom {
  text-shadow: 2px 2px 2px black !important;
}


/*--------------------------------------------------------------
# Modern Carousel Styles - Azul Profissional + Neon
--------------------------------------------------------------*/

.carroussel-container2 {
  padding: 60px 40px;
  border-radius: 0 0 30px 30px;
}

/* .carroussel-container2::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -20%;
  width: 800px;
  height: 800px;
  background: radial-gradient(circle, rgba(0, 217, 255, 0.15) 0%, transparent 70%);
  border-radius: 50%;
  animation: float 8s ease-in-out infinite;
} */

.carroussel-container2::after {
  content: '';
  position: absolute;
  bottom: -30%;
  left: -15%;
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(0, 217, 255, 0.1) 0%, transparent 70%);
  border-radius: 50%;
  animation: float 10s ease-in-out infinite reverse;
}

@keyframes float {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  50% {
    transform: translate(20px, 20px) scale(1.1);
  }
}

.texto-claro {
  color: rgba(255, 255, 255, 0.95);
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.text-shadow--custom {
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

/* Badge de destaque */
.carroussel-container2 .bg-primary {
  background: linear-gradient(135deg, var(--mx3-style-primary, #00D9FF) 0%, #0A61C9 100%);
  color: white;
  font-weight: 700;
  padding: 8px 20px;
  border-radius: 20px;
  box-shadow: 0 4px 15px rgba(0, 217, 255, 0.4);
  animation: pulse-glow 2s ease-in-out infinite;
}

@keyframes pulse-glow {
  0%, 100% {
    box-shadow: 0 4px 15px rgba(0, 217, 255, 0.4);
  }
  50% {
    box-shadow: 0 6px 25px rgba(0, 217, 255, 0.6);
  }
}

/* TÃ­tulo principal */
.carroussel-container2 h1 {
  font-size: 3.5rem;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 20px;
}

.carroussel-container2 h1 .text-primary {
  color: var(--mx3-style-primary, #00D9FF) !important;
  background: linear-gradient(135deg, var(--mx3-style-primary, #00D9FF) 0%, #00F0FF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* BotÃµes modernos */
.carroussel-container2 button {
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 12px;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.carroussel-container2 button:first-of-type {
  background: linear-gradient(135deg, var(--mx3-style-primary, #00D9FF) 0%, #0A61C9 100%);
  color: white;
  border: none;
  box-shadow: 0 6px 25px rgba(0, 217, 255, 0.4);
}

.carroussel-container2 button:first-of-type:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 35px rgba(0, 217, 255, 0.6);
}

.carroussel-container2 button:last-of-type {
  background: rgba(255, 255, 255, 0.15);
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
}

.carroussel-container2 button:last-of-type:hover {
  background: rgba(255, 255, 255, 0.25);
  border-color: var(--mx3-style-primary, #00D9FF);
  transform: translateY(-3px);
}

/* EstatÃ­sticas */
.carroussel-container2 .grid > div {
  text-align: center;
  padding: 15px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.carroussel-container2 .grid > div:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: var(--mx3-style-primary, #00D9FF);
  transform: translateY(-5px);
}

.carroussel-container2 .grid p:first-child {
  color: var(--mx3-style-primary, #00D9FF);
  font-size: 2.5rem;
  font-weight: 800;
  margin-bottom: 5px;
  text-shadow: 0 0 20px rgba(0, 217, 255, 0.5);
}

.carroussel-container2 .grid p:last-child {
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9rem;
}

/* Card de produto */
.bg-item-produto-carrossel2 {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.05) 100%);
  backdrop-filter: blur(20px);
  border: 2px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.3);
  transition: all 0.4s ease;
}

.bg-item-produto-carrossel2:hover {
  transform: translateY(-10px) scale(1.02);
  border-color: var(--mx3-style-primary, #00D9FF);
  box-shadow: 0 20px 60px rgba(0, 217, 255, 0.4);
}

.bg-item-produto-carrossel2 img {
  filter: drop-shadow(0 20px 50px rgba(0, 217, 255, 0.55));
}

/* NavegaÃ§Ã£o do carrossel */
.carousel-nav-btn {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.3);
  color: white;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: absolute;
  z-index: 10;
}

.carousel-nav-btn:hover {
  background: var(--mx3-style-primary, #00D9FF);
  border-color: var(--mx3-style-primary, #00D9FF);
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(0, 217, 255, 0.4);
}

.text-shadow-custom{
  text-shadow: 2px 2px 5px black;
}
</style>

<style src="./Carroussel2.css"></style>